module.exports = __webpack_public_path__ + "static/survillance-738f88af5b091fc2c950b08e88bd7c84.png";